import { ErrorInfo, PureComponent, type ReactNode } from 'react';

import { captureExceptionWithTags } from 'src/utils/sentry';

type RenderErrorProps = {
  sentryEventId: string | null;
};

type Props = {
  children: ReactNode;
  componentId: string;
  renderError: (props: RenderErrorProps) => ReactNode;
};

type State = {
  hasError: boolean;
  sentryEventId: string | null;
};

export class SentryErrorBoundary extends PureComponent<Props, State> {
  static getDerivedStateFromError(error: any) {
    // eslint-disable-next-line no-console
    console.error(error);
    return {
      hasError: true,
    };
  }

  state = {
    hasError: false,
    sentryEventId: null,
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error(errorInfo.componentStack);
    captureExceptionWithTags(
      error,
      { component: this.props.componentId },
      { componentStack: errorInfo.componentStack ?? '' }
    ).then((sentryEventId: string) => {
      this.setState({ sentryEventId });
    });
  }

  render() {
    const { hasError, sentryEventId } = this.state;
    const { children, renderError } = this.props;

    if (!hasError) {
      return children;
    }

    return renderError({ sentryEventId });
  }
}
